/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Code_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Generated activation code" |
*
* @param {Offline_Activation_Code_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_code_aria_label = /** @type {((inputs?: Offline_Activation_Code_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Code_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'activation genere")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generierter Aktivierungscode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice di attivazione generato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сгенерированный код активации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de activación generado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成的激活码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("生成されたアクティベーションコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जनरेट किया गया सक्रियण कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de ativação gerado")
	return /** @type {LocalizedString} */ ("Generated activation code")
});